/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BaseInviteSchema
 */
export interface BaseInviteSchema {
    /**
     * 
     * @type {string}
     * @memberof BaseInviteSchema
     */
    email: string;
    /**
     * 
     * @type {Date}
     * @memberof BaseInviteSchema
     */
    created: Date;
}

/**
 * Check if a given object implements the BaseInviteSchema interface.
 */
export function instanceOfBaseInviteSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "created" in value;

    return isInstance;
}

export function BaseInviteSchemaFromJSON(json: any): BaseInviteSchema {
    return BaseInviteSchemaFromJSONTyped(json, false);
}

export function BaseInviteSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaseInviteSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'created': (new Date(json['created'])),
    };
}

export function BaseInviteSchemaToJSON(value?: BaseInviteSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'created': (value.created.toISOString()),
    };
}

